import { useState } from 'react'
import { alpha, Box, Fade, Popper, Tooltip, useTheme } from '@mui/material'

import LegendGlobal from './LegendGlobal'
import LegendBuildings from './LegendBuildings'
import { useTranslation } from 'react-i18next'

const Legend = ({ mapsView, ...props }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    setOpen((prev) => !prev)
  }

  if (mapsView === 'global') {
    return null
  }

  return (
    <>
      <Tooltip
        arrow
        placement="left"
        title={t(`cartography.maps.controls.legend_${open ? 'off' : 'on'}`)}
      >
        <Box
          sx={{
            cursor: 'pointer',
            backgroundColor: 'white',
            minHeight: '40px',
            minWidth: '40px',
            maxHeight: '40px',
            maxWidth: '40px',
            borderRadius: '50%',
            border: 'solid 1px',
            color: '#464646',
            borderColor: 'border.primary',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: `0 12px 16px -8px ${alpha(
              theme.palette.common.black,
              0.24,
            )}`,
            '&:hover': {
              color: theme.palette.primary.main,
            },
            fontSize: '16px',
            fontWeight: 400,
          }}
          onClick={handleClick}
        >
          <i className="fa-solid fa-info"></i>
        </Box>
      </Tooltip>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="left-end"
        disablePortal
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              {
                mapsView === 'global'
                  ? (
                    <LegendGlobal mapsView={mapsView} />
                  ) : (
                      <LegendBuildings
                        onStateFiltersChange={props?.onStateFiltersChange}
                      />
                    )
              }
            </div>
          </Fade>
        )}
      </Popper>
    </>
  )
}

export default Legend